export const msgType = {
  info: 'info',
  message: 'message',
};
